define.alias("shared/components/shared/ui/switcher/trigger", "calendar/components/shared/ui/switcher/trigger");